<div class="profile-address__wrapper">
  <div *ngIf="shippingAddresses.length > 0">
    <div class="address-panels">
      <div
        *ngFor="let address of shippingAddresses"
        class="panel"
        [ngClass]="{ 'mb-10': address.toggle }"
      >
        <div
          class="panel-content flex justify-space-between align-center mb-2"
          [ngClass]="{ open: address.toggle }"
        >
          <div class="company-name">{{ address.companyName }}</div>
          <div class="company-address">{{ address.addressText }}</div>
          <div class="action">
            <lum-ui-icon
              class="cursor-pointer"
              icon="check-circle"
              [width]="20"
              [height]="20"
              [color]="address.default ? '#689f60' : '#5563d6'"
              (click)="onSetDefault(address)"
            ></lum-ui-icon>
            <lum-ui-icon
              *ngIf="!address.default"
              class="cursor-pointer"
              icon="delete-bin-2"
              [width]="20"
              [height]="20"
              color="#5563d6"
              (click)="onDelete(address)"
            ></lum-ui-icon>
            <ng-container *ngIf="!address.toggle; else checkEdit">
              <lum-ui-icon
                class="cursor-pointer"
                icon="edit"
                [width]="20"
                [height]="20"
                color="#5563d6"
                (click)="address.toggle = !address.toggle"
              ></lum-ui-icon>
            </ng-container>
            <ng-template #checkEdit>
              <lum-ui-icon
                class="cursor-pointer"
                icon="chevron-up"
                [width]="20"
                [height]="20"
                color="#5563d6"
                (click)="address.toggle = !address.toggle"
              ></lum-ui-icon>
            </ng-template>
          </div>
        </div>
        <lum-client-profile-add-shipping-address-form
          *ngIf="address.toggle"
          class="my-3"
          [address]="address"
          [client]="getClient"
          (closeShippingForm)="address.toggle = false"
        ></lum-client-profile-add-shipping-address-form>
      </div>
    </div>
    <div [ngClass]="addAddressToggle ? 'mb-10' : 'mb-3'">
      <button
        type="button"
        class="lum-button lum-button--secondary lum-button--large mb-3"
        mat-button
        (click)="addAddressToggle = !addAddressToggle"
      >
        Add New Shipping Address

        <lum-ui-icon
          class="ml-2"
          icon="add-circle"
          [width]="18"
          [height]="18"
          color="#5563d6"
        ></lum-ui-icon>
      </button>
    </div>
  </div>
  <lum-client-profile-add-shipping-address-form
    *ngIf="addAddressToggle || shippingAddresses.length === 0"
    [client]="getClient"
    (closeShippingForm)="addAddressToggle = false"
  ></lum-client-profile-add-shipping-address-form>

  <div class="lum-modal__footer mt-4 w-p100" mat-dialog-actions>
    <div class="flex ml-auto lum-modal__action">
      <button
        type="button"
        class="lum-button lum-button--secondary mr-2"
        mat-button
        (click)="onChangeTab()"
      >
        <lum-ui-icon
          icon="chevron-left"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Previous
      </button>

      <button
        mat-button
        type="button"
        [disabled]="hasInvalidInput || (loading$ | async)"
        class="lum-button"
        (click)="onSaveChanges()"
      >
        <ng-container *ngIf="!(loading$ | async); else loader">
          Save
          <lum-ui-icon
            class="ml-2-5"
            icon="content-save"
            color="#ffffff"
            width="23"
            height="23"
          ></lum-ui-icon>
        </ng-container>
        <ng-template #loader>
          <mat-progress-spinner
            class="progress-spinner"
            diameter="23"
            mode="indeterminate"
          ></mat-progress-spinner>
        </ng-template>
      </button>
    </div>
  </div>
</div>
